module.exports = __webpack_public_path__ + "img/three1Orange.30006717.jpg";